// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPlayerMiniControls__controls-d3d736 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.VideoPlayerMiniControls__controls-background-ea86d9 {
  background-color: var(--addition-40_40);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.VideoPlayerMiniControls__controls-top-b61934 {
  display: flex;
  padding: 12px;
}

.VideoPlayerMiniControls__controls-center-e9d35c {
  display: flex;
  justify-content: center;
}

.VideoPlayerMiniControls__controls-bottom-a7e188 {
  padding: 12px;
  position: relative;
}

.VideoPlayerMiniControls__close-c64361 {
  margin-inline-start: auto;
}

.VideoPlayerMiniControls__action-button-e841c6 {
  color: var(--addition-50);
}

.VideoPlayerMiniControls__action-button-e841c6:focus-visible {
  color: var(--ib-color-hover); /* TODO: change design */
}

.VideoPlayerMiniControls__progress-a68b7e {
  height: 4px;
  margin: 9px 0 13px;
  --progress-pin-size: 14px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/VideoPlayer/VideoPlayerMiniControls/VideoPlayerMiniControls.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,uCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,4BAAA,EAAA,wBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EAEA,yBAAA;AAAF","sourcesContent":[".controls {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.controls-background {\n  background-color: var(--addition-40_40);\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.controls-top {\n  display: flex;\n  padding: 12px;\n}\n\n.controls-center {\n  display: flex;\n  justify-content: center;\n}\n\n.controls-bottom {\n  padding: 12px;\n  position: relative;\n}\n\n.close {\n  margin-inline-start: auto;\n}\n\n.action-button {\n  color: var(--addition-50);\n}\n\n.action-button:focus-visible {\n  color: var(--ib-color-hover); /* TODO: change design */\n}\n\n.progress {\n  height: 4px;\n  margin: 9px 0 13px;\n\n  --progress-pin-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `VideoPlayerMiniControls__controls-d3d736`,
	"controls-background": `VideoPlayerMiniControls__controls-background-ea86d9`,
	"controlsBackground": `VideoPlayerMiniControls__controls-background-ea86d9`,
	"controls-top": `VideoPlayerMiniControls__controls-top-b61934`,
	"controlsTop": `VideoPlayerMiniControls__controls-top-b61934`,
	"controls-center": `VideoPlayerMiniControls__controls-center-e9d35c`,
	"controlsCenter": `VideoPlayerMiniControls__controls-center-e9d35c`,
	"controls-bottom": `VideoPlayerMiniControls__controls-bottom-a7e188`,
	"controlsBottom": `VideoPlayerMiniControls__controls-bottom-a7e188`,
	"close": `VideoPlayerMiniControls__close-c64361`,
	"action-button": `VideoPlayerMiniControls__action-button-e841c6`,
	"actionButton": `VideoPlayerMiniControls__action-button-e841c6`,
	"progress": `VideoPlayerMiniControls__progress-a68b7e`
};
module.exports = ___CSS_LOADER_EXPORT___;
